export const GLOBAL_REGION_ID = 0;

const ALL_COUNTRIES_IN_REGION_ID = 'ALL';

export const checkCountryVisibility = (countryCode: string | null, visibleCountryCodes: string[]) => {
    const countryCodeString = countryCode ? countryCode.toString() || ALL_COUNTRIES_IN_REGION_ID : ALL_COUNTRIES_IN_REGION_ID;

    /* return true if countryCodes config has "ALL" else check for countryCode passed through query params*/
    return visibleCountryCodes.includes(ALL_COUNTRIES_IN_REGION_ID) || visibleCountryCodes.includes(countryCodeString);
};

export const parseConfig = (config: string) => {
    return JSON.parse(config) || {};
};
